import {createReducer, on} from "@ngrx/store";
import {UsersActions} from "../actions";
import {UserDto, UserDtoExtended, UserListDto} from "@esa/api";


export const usersFeatureKey = 'users';

export interface UsersState {
  users: UserDto[];
  totalUsers: number;
  loggedInUser: UserDtoExtended;
  userList: UserListDto[];
  selectedUser: UserDto;
  selectedUserId: string;
  userDisabled: boolean;
}

const initialState: UsersState = {
  users: [],
  totalUsers: 0,
  loggedInUser: null,
  userList: [],
  selectedUser: null,
  selectedUserId: '',
  userDisabled: false
};

export const usersReducer = createReducer(
  initialState,
  on(UsersActions.getUsersSuccess, (state, { users, totalUsers }) => ({ ...state, users, totalUsers,  selectedUserId: '', selectedUser: null  })),
  on(UsersActions.getLoggedInUserSuccess, (state, { loggedInUser }) => ({ ...state, loggedInUser })),
  on(UsersActions.getUserListSuccess, (state, { userList }) => ({ ...state, userList })),
  on(UsersActions.setSelectedUserId, (state, { selectedUserId }) => ({ ...state, selectedUserId })),
  on(UsersActions.getUserByIdSuccess, (state, { selectedUser}) => ({ ...state, selectedUser })),
  on(UsersActions.updateUserSuccess, (state) => ({ ...state, selectedUser: null, selectedUserId: '' })),
  on(UsersActions.deleteUserSuccess, (state) => ({ ...state, selectedUser: null, selectedUserId: '' })),
  on(UsersActions.reactivateUserSuccess, (state) => ({ ...state, selectedUser: null, selectedUserId: '' })),
  on(UsersActions.setUserDisabled, (state, {userDisabled}) => ({ ...state, userDisabled }))
);
